import { render, staticRenderFns } from "./GenresTable.vue?vue&type=template&id=709e3b7d&scoped=true"
import script from "./GenresTable.vue?vue&type=script&lang=js"
export * from "./GenresTable.vue?vue&type=script&lang=js"
import style0 from "./GenresTable.vue?vue&type=style&index=0&id=709e3b7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709e3b7d",
  null
  
)

export default component.exports